// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"87c0f6fc","200":"6337b2ab","260":"1e1da677","518":"d7090a52","522":"c83604b1","593":"c4f7bf4c","632":"5c857992","697":"dccdad48","754":"cb347e93","827":"7d056b4c","873":"5b933412","945":"4cd90407","969":"506f6610"}[chunkId] + ".chunk.js";
};